import React from 'react';
import { Icon } from './Icon.js';
export const IconHouseChart = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 2L2 9.5V10.5L4 11V21H20V11L22 10.5V9.5L12 2Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M8 15L10.5 12.5L12 14L13.5 15.5L16 13", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconHouseChart.js.map